import elementLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  ...elementLocale,
  menu: {
    home: '首页',
    product: '产品介绍',
    news: '新闻与资源',
    about: '关于我们',
    contact: '联系我们',
    case: '产品案例',
    assess: '工业场景评估'
  },
  hero: {
    title: "广纳智能创新 丰盈永续未来",
    subtitle: "加速实现净零碳排，为各行业提供创新智能解决方案",
    exploreBtn: '探索产品',
    contactBtn: '联系我们',
    tag1: '水泥行业',
    tag2: '石化行业',
    tag3: '钢铁行业',
    product1: '设备安全异常预警',
    product2: '实时质量预测',
    product3: '工艺参数最佳化',
    product4: '环保智能管家'
  },
  siteName: '广丰人工智能官网',
  siteDescription: '加速实现净零碳排，为各行业提供创新智能解决方案',

  // ===== 首页各区块 =====
  home: {
    keywords: '智能科技产品, 广丰智能,广丰人工智能科技（山东）有限公司，重工业AI,智能化解决方案提供者',
    about: {
      title: '广丰人工智能',
      titleSpan: '科技（山东）有限公司',
      desc: '聚焦人工智能技术在重工业领域的深度赋能，以推动行业ESG发展为核心使命，致力于通过技术创新助力企业实现"净零碳排放"与"环境可持续性"目标。',
      feat1Title: '智能化解决方案',
      feat1Text: '覆盖水泥、石化、钢铁等高能耗领域，提供从生产流程优化到碳排放精准管控的一体化服务。',
      feat2Title: '环保产业链服务',
      feat2Text: '提供工业滤袋研发制造、环保智能管家等一站式环保解决方案，形成"智能技术+环保装备"双轮驱动体系。',
      en: 'Grand Founts AI Technology (Shandong) Co., Ltd. — Accelerating net-zero carbon emissions through intelligent innovation.'
    },
    products: {
      title: '助力企业实现',
      titleSpan: '智能化制造',
      sub: '加速重工业实践 ESG 发展，实现净零碳排放和环境永续',
      viewDetail: '查看详情 →',
      learnMore: '了解更多'
    },
    scene: {
      title: '应用',
      titleSpan: '场景'
    },
    news: {
      title: '新闻',
      titleSpan: '动态',
      readMore: '阅读更多'
    },
    honor: {
      title: '荣誉',
      titleSpan: '资质'
    },
    contact: {
      title: '联系',
      titleSpan: '我们',
      tel: '联系电话',
      hours: '工作时间',
      hoursValue: '周一至周五 08:30–12:00，13:00–17:30',
      address: '公司地址',
      addressValue: '山东省日照市烟台路99号科创中心11号楼6楼608室'
    },
    footer: {
      legal: '法律声明',
      privacy: '隐私政策',
      personalInfo: '个人信息保护',
      sitemap: '网站地图'
    }
  },

  // ===== 产品案例列表页 =====
  case: {
    pageTitle: '产品案例'
  },

  // ===== 案例详情页 =====
  caseDetail: {
    intro: '案例简介',
    process: '核心流程',
    detail: '详细说明'
  },

  // ===== 新闻列表页 =====
  news: {
    pageTitle: '新闻中心'
  },

  // ===== 新闻详情页 =====
  newsDetail: {
    pageTitle: '新闻详情',
    rizhaoLink: '日照新闻专访视频链接',
    qiluLink: '齐鲁晚报专访'
  },

  // ===== 产品介绍页 =====
  product: {
    currentStatus: '当前现况',
    painPoints: '需求痛点',
    solution: '解决方案',
    realApp: '实际应用',
    benefits: '达成效益',
    ecoButler: '环保智能管家',
    filterMedia: '滤料',
    filterCloth: '滤布',
    filterCartridge: '滤桶'
  },

  // ===== 关于我们页 =====
  about: {
    pageTitle: '企业简介',
    positioning: '企业定位',
    positioningText: '广丰人工智能科技（山东）有限公司是日照市高新区重点引进的高科技企业，聚焦人工智能技术在重工业领域的深度赋能，以推动行业ESG（环境、社会与治理）发展为核心使命，致力于通过技术创新助力企业实现"净零碳排放"与"环境可持续性"目标。',
    coreBiz: '核心业务：重工业智能化解决方案',
    coreBizText: '公司深耕重工业智能化升级赛道，在水泥、石化、钢铁、特化等高能耗、高排放领域积累了丰富的场景化经验。核心解决方案覆盖智能化生产管理、数据驱动决策优化、全流程节能降耗三大方向，通过AI算法模型与工业物联网的深度融合，为企业提供从生产流程优化到碳排放精准管控的一体化服务，相关技术指标与实施成效处于行业领先水平。',
    extLayout: '延伸布局：环保产业链一站式服务',
    extLayoutText: '除人工智能主营业务外，公司同步布局环保产业链，提供工业滤袋研发制造、环保智能管家、设备安全异常预警、实时质量预测、工艺参数最佳化、滤袋销售及售后维护等一站式环保解决方案，形成"智能技术+环保装备"双轮驱动的服务体系，全方位满足客户绿色低碳转型需求。',
    accreditations: '权威认证与荣誉资质',
    accreditationsText: '凭借扎实的技术实力与市场表现，公司已获得多项权威资质与荣誉认证：',
    li1: '科技型企业认定：获评山东省科学技术厅颁发的"山东省科技型中小企业"；',
    li2: '信用体系认证：入选商务部国际贸易经济合作研究院信用评级与认证中心"信用认证企业"；',
    li3: '知识产权保护：自主研发的"人工智能设备故障预警系统""人工智能生产能耗控制系统"取得国家软件著作权；',
    li4: '创新赛道突破：成功入围第十四届中国创新创业大赛新一代信息技术全国赛，展现前沿技术应用潜力与行业竞争力。',
    mission: '企业使命',
    coreValues: '核心价值',
    techCore: '技术核心',
    valueProposition: '价值主张',
    coreTeam: '核心团队',
    values: {
      innovation: '创新引领',
      innovationText: '我们的团队致力于将尖端AI技术融入工业实践，推动产业数字化转型。',
      sustainability: '可持续发展',
      sustainabilityText: '我们致力于为企业和社会创造长期价值。',
      expertise: '专业与热情',
      expertiseText: '我们为每一位团队成员提供自由发挥创造力的平台和广阔的职业发展空间。'
    },
    techValues: {
      ai: 'AI算法',
      aiText: '自主研发的数据优化算法。',
      sensor: '传感器网络',
      sensorText: '多点采集设备运行数据。',
      monitor: '实时监控平台',
      monitorText: '数据驱动智能调控。'
    },
    missionValues: {
      innovation: '技术创新',
      innovationText: '通过人工智能技术，加速重工业实践ESG发展。',
      results: '效果显著',
      resultsText: '助力企业提质增效，实现净零碳排放和环境永续。'
    },
    propositionValues: {
      cost: '节约成本',
      costText: '以低资本支出实现高节能收益。',
      efficiency: '提升效率',
      efficiencyText: '通过智能优化提升运营整体效率。',
      risk: '减少风险',
      riskText: '实现能源效率最适化并降低生产中断和不可逆风险。'
    }
  },

  // ===== 联系我们页 =====
  contact: {
    pageTitle: '联系我们',
    description: '想进一步了解我们的产品与解决方案吗？欢迎来信service@grandfounts.com，致电+86-0633-8179588或填写下列表单与我们联系！',
    name: '姓名 (必填)',
    phone: '电话（必填）',
    email: '邮箱 (必填)',
    company: '公司名称',
    address: '公司地址',
    other: '其他',
    submit: '提交',
    namePlaceholder: '请输入您的姓名',
    phonePlaceholder: '请输入您的联系电话',
    emailPlaceholder: '请输入您的邮箱',
    companyPlaceholder: '请输入公司名称',
    addressPlaceholder: '请输入公司地址',
    otherPlaceholder: '其他信息',
    submitSuccess: '表单已成功提交！',
    submitFail: '提交失败: ',
    followWechat: '关注公众号',
    followDouyin: '关注抖音',
    companyLocation: '公司位置'
  },

  // ===== 荣誉列表页 =====
  honor: {
    honorType: '荣誉类',
    softwareType: '软件著作类',
    competitionType: '大赛类'
  }
}
